import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { Icon } from "@iconify/vue2"


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  name: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "24",
  },
  local: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    required: false,
  },
  iconSet: {
    type: String,
    default: "solar",
  },

  type: {
    type: String,
    default: "outline",
  },
},
  setup(__props) {

const { name, local, size, color, iconSet, type } = __props



const icon = computed(() => {
  return local ? require(`@/assets/icons/${name}.svg`) : null
})

const iconName = computed(() => (type ? `${iconSet}:${name}-${type}` : `${iconSet}:${name}`))

return { __sfc: true,icon, iconName, Icon }
}

})